module.exports = __webpack_public_path__ + "static/media/slider2.999b83fb.png";